<template>
  <router-link
    class="unitProduct-link"
    :to="{
      name: 'unitProduct',
      params: {
        unitId: unitProduct.unit_id,
        productId: unitProduct.product_id
      }
    }"
  >
    <v-card class="mx-auto unitProductCard" max-width="280" :loading="loading">
      <template v-slot:loader="{ isActive }">
        <v-progress-linear
          :active="isActive"
          color="deep-purple"
          height="4"
          indeterminate
        ></v-progress-linear>
      </template>
      <v-img
        v-if="unitProduct.img_path"
        :src="`${unitProduct.img_path}`"
        height="200px"
        cover
        class="fitProductImage"
      ></v-img>
      <v-img
        v-else
        src="@/assets/static/images/noImage.png"
        height="200px"
        cover
        class="fitProductImage"
      ></v-img>
      <div style="text-align: left">
        <div class="card-title bold">{{ unitProduct.product_name }}</div>
      </div>
      <v-chip-group style="padding: 0px 10px;">
        <v-chip
          >{{ $t('stock') }}:
          <strong>
            {{ unitProduct.stock_curr }}/{{ unitProduct.stock_max }}</strong
          ></v-chip
        >
      </v-chip-group>
      <!-- <div class="trashIcon" @click="deleteUnitProduct">
					<font-awesome-icon icon="trash" />
			</div> -->
    </v-card>
  </router-link>
</template>

<script>
export default {
  data() {
    console.log(this)
    return {
      unitId: this.unitProduct.unit_id,
      productId: this.unitProduct.product_id,
      baseUrl: process.env.VUE_APP_API_URL,
      loading: false
    }
  },
  methods: {
    // deleteUnitProduct(event) {
    //   event.preventDefault()
    //   if (confirm('are you sure?')) {
    //     this.$store
    //       .dispatch('unitProduct/removeUnitProduct', {
    //         unitId: this.unitId,
    //         productId: this.productId,
    //       })
    //       .then(() => {
    //         this.$store.dispatch('unitProduct/fetchUnitProducts', this.unitId)
    //       })
    //       .catch((e) => console.log(e))
    //   }
    // },
    reserve() {
      this.loading = true
      setTimeout(() => (this.loading = false), 2000)
    }
  },
  props: {
    unitProduct: {
      type: Object,
      default: () => {
        return {}
      }
    },
    unit: {
      type: Object,
      default: () => {
        return {}
      }
    },
    product: {
      type: Object,
      default: () => {
        return {}
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.unitProduct-link {
  text-decoration: none;
}

.fitProductImage {
  width: 100% !important;
  object-fit: cover !important;
}

.unitProductCard {
  height: 310px;
  margin: 20px 10px !important;
}
.card-title {
  width: 220px;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  margin: 15px 10px 0 10px;
  text-align: left;
  font-size: 1.1rem;
  font-weight: 800;
}
.bold {
  font-weight: 700 !important;
}

.trashIcon {
  background: var(--primaryDark);
  color: var(--bright);
  padding: 10px;
  border: none;
  border-radius: 5px;
  width: 35px;
  height: 40px;
  position: absolute;
  right: 10px;
  margin: 0;
  bottom: 10px;
}

.iconWrapper {
  display: flex;
  flex-wrap: nowrap;
  align-items: right;
  justify-content: right;
  margin: -10px 5px 5px 0px;
}

.icon {
  font-size: 1.3em;
  padding: 1px;
}

@media screen and (min-width: 500px) {
  .unitProductCard:hover {
    background: rgba(128, 128, 128, 0.2) !important;
    box-shadow: rgba(0, 0, 0, 0.117647) 0px 1px 6px,
      rgba(0, 0, 0, 0.117647) 0px 1px 4px;
    margin: 10px !important;
    transform: scale(1.03);
  }
}

@media only screen and (max-device-width: 769px) {
  .unitProductCard {
    height: auto !important;
  }
}

@media screen and (max-width: 500px) {
  .unitProductCard {
    margin: auto !important;
    margin-bottom: 20px !important;
  }
  .card-title {
    width: 225px !important;
    margin-top: 10px;
    line-height: 30px;
  }
}
@media only screen and (min-device-width: 300px) and (max-device-width: 359px) {
  .card-title {
    width: 240px;
    font-size: 1.2rem;
    text-align: left;
  }
}

@media only screen and (min-device-width: 360px) and (max-device-width: 379px) {
  .card-title {
    width: 270px;
  }
}
</style>
